import styled from 'styled-components';

export const StyledUserPanelResultsPlace = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    height: 50px;
`;
